import React from 'react';
import { Box } from '@mui/material';
import { ClientPortalTask } from '../../types';
import { createTruncatedTextFormat } from 'framework/ui/field';

interface TaskSectionHeaderProps {
  data: ClientPortalTask;
  actions?: React.ReactNode;
  isEdit?: boolean;
}

const TaskSectionHeader = ({ isEdit, data, actions }: TaskSectionHeaderProps) => {
  const formatTitle = createTruncatedTextFormat(150, {
    variant: 'h1',
    fontWeight: 600,
    color: 'brand',
    sx: { mb: 0 },
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={!isEdit ? 'space-between' : 'flex-end'}
        gap={1}
        sx={{ width: '100%' }}
      >
        {!isEdit && (
          <Box display="flex" alignItems="center" flexDirection={'row'} gap={2} sx={{ minWidth: 0, width: '60%' }}>
            {formatTitle(data?.title)}
          </Box>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>{actions}</Box>
      </Box>
    </Box>
  );
};

export default TaskSectionHeader;
